import { Fragment, useEffect, useState } from 'react';
import { ProviderProductApi } from '@recargas-dominicanas/core/api';
import { validators } from '@recargas-dominicanas/core/utils';
import { type ProviderProduct } from '@recargas-dominicanas/core/types';
import { TextField, FieldError } from '@recargas-dominicanas/core/components';
import { Modal } from '../../../../components/modal/modal.component';
import { ProviderStore } from '../../../../store/providerStore';
import { style } from './percent-modal.module.css';

interface Props {
  open: boolean;
  providerProduct: ProviderProduct;
  onClose: () => void;
}

export function PercentModal(props: Props) {

  const {
    open,
    providerProduct,
    onClose
  } = props;

  const [providerProducts, setProviderProducts] = useState<ProviderProduct[]>([]);
  const [error, setError] = useState<string>();

  useEffect(() => {
    setProviderProducts([
      providerProduct,
      ...providerProduct.product.providerProducts?.filter(product => product.id !== providerProduct.id) ?? []
    ]);
  }, [open]);

  function handleChange(providerProduct: ProviderProduct, value: number) {
    setProviderProducts(providerProducts => providerProducts.map(product => ({
      ...product,
      percent: providerProduct.id === product.id ? value : product.percent
    })));
  }

  async function handleSave() {

    const isValid = providerProducts.every(product => product.percent >= 0 && product.percent <= 100 && !isNaN(product.percent));
    const totalPercent = providerProducts.reduce((total, product) => total + product.percent, 0);

    if (!isValid) {
      setError('Campos invalidos');
      return;
    }

    if (totalPercent !== 100) {
      setError('El porcentaje total debe ser del 100%');
      return;
    }

    setError(undefined);

    try {

      await ProviderProductApi.updatePercent(providerProducts.map(product => ({ 
        id: product.id, 
        percent: product.percent 
      })));

      await ProviderStore.fetchProducts(providerProduct.provider.id);

      handleClose();

    } catch (err) {

      console.error(err);

      setError('Error actualizando porcentaje');
    }
  }

  function handleClose() {
    setError(undefined);
    onClose();
  }

  function getError(percent: number) {
    if (percent < 0) {
      return 'Valor minimo 0';
    } else if (percent > 100) {
      return 'Valor maximo 100';
    } else if (isNaN(percent)) {
      return 'Valor invalido';
    } else {
      return undefined;
    }
  }

  return (
    <Modal
      open={open}
      title='Editar porcentaje'
      style={style.modal}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      {providerProducts?.map(providerProduct =>
        <Fragment key={providerProduct.id}>
          <TextField 
            style={style.textField}
            type='number'
            label={providerProduct.provider.name}
            value={providerProduct.percent.toString()}
            onChange={value => handleChange(providerProduct, parseInt(value))}
            validators={[validators.required, validators.min(0), validators.max(0)]}/>
          <FieldError message={getError(providerProduct.percent)} />
        </Fragment>
      )}
    </Modal>
  );
}
